<template>
  <ul class="pb-medium md:container md:pt-44 md:pb-25 locations-list">
    <LocationsListItem
      v-for="(location, index) in locations"
      :key="index"
      :location="location"
      :first="index === 0"
    />
  </ul>
</template>

<script>

export default {
  name: 'LocationsList',
  props: {
    locations: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="postcss" scoped>
  .locations-list > * + * {
    margin-top: 3rem;
  }
</style>
